import { Maybe } from '../../common/data.js';
import { Context } from '../../common/context.js';
import { ensure, queue } from '../../common/util.js';
import { joinLeague } from '../lib/api.js';
import { showAlert, showErrorAlert } from './popup.js';
import { ContentExtras, ContentItem } from '../../common/data/content.js';
import { ContentBlock, ContentContext, initContentContext } from './content.js';
import { PublicAccount } from '../../common/data/accounts.js';
import { AuthForm } from './auth.js';

export function JoinLeaguePage({ context, league, welcome, extras, secret, availableServices }: {
	context: Context;
	league: PublicAccount;
	welcome: Maybe<ContentItem>;
	extras: Maybe<ContentExtras>;
	secret: Maybe<string>;
	availableServices: string[];
}) {

	const { user } = context;

	const join = queue(async () => {
		const res = await joinLeague({ league: league.id, secret: ensure(secret) }).catch(showErrorAlert);
		if (res?.success) await showAlert(res.success, 'info');
		if (res?.redirect) location.href = res.redirect;
	});

	if (!secret) return <div class="join-league">
		<h1>This link is wrong or has expired.</h1>
		<p>Please ask the admin for a new link.</p>
	</div>;

	return <div class="join-league">
		
		{welcome ? <div className="join-league__welcome">
			<ContentContext.Provider value={initContentContext({
				target: ['web'],
				domain: context.domain,
				extras: ensure(extras),
			})}>
				<ContentBlock item={welcome} />
			</ContentContext.Provider>
		</div> : <div className="join-league__welcome">
		
			<h1>You've been invited to join {league.account_name}</h1>
			<p>Sign up now to receive your every day discount and help support {league.account_name}.</p>
		
		</div>}
		
		{!user && <>
			<p>Please create a new account or sign in to an existing one to be able to join:</p>
			<AuthForm />
		</>}
		{user && <button class="join-league__join" onClick={join}>Enroll</button>}
		
	</div>;

}
